// date format used if no user setting
// TODO: add default format all over Prime
export const DEFAULT_DATE_FORMAT = "MM/DD/YYYY"
